export default __webpack_public_path__ + "static/media/tick_exp_icon.55b3c9ee.svg";